import { useEffect, useState } from "react";

/** Loads a private, credentialed media resource into an <img> via an object URL. */
export function AuthImg({ src, alt }: { src: string; alt: string }) {
  const [url, setUrl] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let revoke: string | null = null;
    let active = true;
    fetch(src, { credentials: "include" })
      .then((r) => (r.ok ? r.blob() : Promise.reject(new Error("load failed"))))
      .then((b) => { if (!active) return; const u = URL.createObjectURL(b); revoke = u; setUrl(u); })
      .catch(() => active && setFailed(true));
    return () => { active = false; if (revoke) URL.revokeObjectURL(revoke); };
  }, [src]);
  if (failed) return <div className="flex h-24 items-center justify-center rounded-lg bg-canvas text-xs text-muted">foto</div>;
  if (!url) return <div className="h-24 animate-pulse rounded-lg bg-canvas" />;
  return <img src={url} alt={alt} className="h-24 w-full rounded-lg object-cover" />;
}
